import React from 'react';
import SvgIconContainer from '../SvgIconContainer';

export default function IconArrowForward(props) {
  const { width, height } = props;
  return (
    <SvgIconContainer {...props}>
      <svg
        width={width || '22'}
        height={height || '16'}
        viewBox="0 0 22 16"
        fill="currentColor"
        fillRule="nonzero"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          cliprule="evenodd"
          d="M13.5504 1.23224C13.6003 1.11109 13.6794 1.00415 13.7806 0.92096C13.8819 0.837766 14.0021 0.780895 14.1306 0.75541C14.2592 0.729925 14.392 0.736617 14.5173 0.774891C14.6426 0.813164 14.7565 0.881831 14.8489 0.974777L21.206 7.33192C21.28 7.40574 21.3387 7.49342 21.3788 7.58997C21.4189 7.68651 21.4395 7.79 21.4395 7.89453C21.4395 7.99905 21.4189 8.10255 21.3788 8.19909C21.3387 8.29563 21.28 8.38332 21.206 8.45713L14.8489 14.8143C14.6997 14.9635 14.4973 15.0473 14.2863 15.0473C14.0753 15.0473 13.8729 14.9635 13.7237 14.8143C13.5745 14.6651 13.4906 14.4627 13.4906 14.2517C13.4906 14.0407 13.5745 13.8383 13.7237 13.6891L18.7251 8.68917H1.57199C1.36123 8.68917 1.15911 8.60545 1.01009 8.45642C0.861065 8.3074 0.777344 8.10528 0.777344 7.89453C0.777344 7.68377 0.861065 7.48165 1.01009 7.33263C1.15911 7.18361 1.36123 7.09988 1.57199 7.09988H18.7251L13.7237 2.09999C13.612 1.98882 13.5359 1.84697 13.5051 1.69246C13.4742 1.53795 13.49 1.37776 13.5504 1.23224Z"
        />
      </svg>
    </SvgIconContainer>
  );
}

IconArrowForward.propTypes = SvgIconContainer.propTypes;
